// MUI Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const NavbarTextButton = ({
  dataTestId,
  title,
  onClick,
  isUnderlined,
  leftIcon = undefined,
  customStyles = {},
}) => {
  return (
    <Button
      data-testid={dataTestId}
      key={title}
      onClick={onClick}
      sx={{
        my: 1.5,
        mr: 3,
      }}
    >
      {leftIcon && (
        <Box
          sx={{
            marginRight: 1,
            fontSize: 20,
            display: "flex",
          }}
        >
          {leftIcon}
        </Box>
      )}
      <Box
        sx={{
          color: "#E7EBF8",
          textTransform: "capitalize",
          fontWeight: 500,
          fontSize: 20,

          borderBottom: "2px solid transparent",

          ...(isUnderlined && {
            fontWeight: "bold",
            borderBottom: "2px solid #E2772E",
            borderRadius: 0,
          }),

          // override the above styles
          ...customStyles,
        }}
      >
        {title}
      </Box>
    </Button>
  );
};

export default NavbarTextButton;
